import NewArtworkPage from "./NewArtworkPage"

export default NewArtworkPage